import MailingListForm from "#app/components/mailingListForm.tsx";
import Footer from "#app/components/navs/footer.tsx";
import Header from "#app/components/navs/header.tsx";
import TourDateTable from "#app/components/tourDateTable.tsx";
import { Icon } from "#app/components/ui/icon.tsx";
// import SocialIcons from "#app/components/ui/socials.tsx";
import YoutubeEmbed from "#app/components/youtubeEmbed.tsx";
import { getEvents } from "#app/utils/bandsintown.server.ts";

import crowbar01 from '../assets/images/crowbar0526-1.jpg'
import crowbar02 from '../assets/images/crowbar0526-2.jpg'
import crowbar03 from '../assets/images/crowbar0526-3.jpg'
import crowbar04 from '../assets/images/crowbar0526-4.jpg'
import dogShirt from '../assets/images/dogShirt.jpg'

import garage01 from '../assets/images/garage01.jpg'
import garage03 from '../assets/images/garage03.jpg'
import albumArt from '../assets/images/laughItOffArt.jpg'
import scriptLogo from '../assets/images/scriptLogo.png'

import { type Route } from './+types/home.ts'

export const links: Route.LinksFunction = () => [
  { rel: 'preload', href: garage01, as: 'image' },
  { rel: 'preload', href: garage03, as: 'image' },
]

export function meta({ matches }: Route.MetaArgs) {
  const rootMatch = (matches as any[]).find(m => m.id === 'root')
  const rootMeta = (rootMatch?.meta ?? []) as Array<Record<string, string>>
  const { origin, path } = rootMatch?.loaderData?.requestInfo ?? {}
  const inherited = rootMeta.filter(m => !('title' in m) && !(m.name === 'description') && !(m.property === 'og:url'))
  return [
    ...inherited,
    { title: "Rohna | Tampa Florida Indie Rock Band" },
    { name: "description", content: "Discover Rohna - Tampa, Florida's rising Indie Alternative Rock band! Catch them live at a venue or festival near you as they take on some of the most iconic stages across the country. Stream and download their music on all platforms!" },
    { property: "og:title", content: "Rohna" },
    { property: "og:site_name", content: "Rohna" },
    { property: 'og:url', content: `${origin}${path}` },
    { property: "og:description", content: "Discover Rohna - Tampa, Florida's rising Indie Alternative Rock band! Catch them live at a venue or festival near you as they take on some of the most iconic stages across the country. Stream and download their music on all platforms!" },
  ]
}

export async function loader() {
  const events = await getEvents()
  return { events }
}

export default function Home({ loaderData }: Route.ComponentProps) {
  const { events } = loaderData;

  return (
    <>
      <Header onHomePage={true}/>
      <main id="main-content" tabIndex={-1}>
        <section className="bg-[url('../assets/images/garage01.jpg')] lg:bg-[url('../assets/images/garage03.jpg')] bg-cover bg-center bg-no-repeat lg:bg-bottom animate-fade-in">
          <div id="hero" className="px-8 pb-12 pt-48 md:pt-80 bg-linear-to-b from-black via-transparent via-30% to-black to-80%">
            <div className="flex flex-col gap-2 md:gap-6 justify-end mt-36 mx-auto">
              <h1 className="sr-only">Rohna - Home</h1>
              <img src={scriptLogo} className="w-[175px] md:w-[450px] xl:w-[500px] 2xl:w-[600px] self-center md:self-auto" alt=""/>
              <p className="text-white md:text-2xl text-center md:text-left mt-2 mx-2">Indie rock from Tampa, FL. New single <i>&quot;Laugh It Off&quot;</i> out now.</p>
              <div className="flex flex-col md:flex-row justify-center md:justify-start gap-2 md:gap-6 mt-2">
                <a href="https://rohna.tunelink.to/laugh-it-off" target="_blank" rel="noopener noreferrer" className="text-white text-center uppercase font-bold text-xl md:text-3xl p-4 md:py-4 md:px-16 rounded-2xl bg-orange transition-all duration-300 ease-in-out shadow-none hover:shadow-orange/50  hover:shadow-lg hover:scale-105">Play Latest<span className="sr-only"> (opens in new tab)</span></a>
                <a href="https://rohnamusic.com/shows" target="_blank" rel="noopener noreferrer" className="text-white text-center uppercase font-bold text-xl md:text-3xl p-4 md:py-4 md:px-16 rounded-2xl bg-none border-4 transition-all duration-300 ease-in-out shadow-none hover:shadow-white/50  hover:shadow-lg hover:scale-105">Tour Dates<span className="sr-only"> (opens in new tab)</span></a>
              </div>
              {/* <div className="flex flex-row items-center gap-4"><SocialIcons size="xl"/></div> */}
            </div>
          </div>
        </section>
        <section id="nowPlaying" className="bg-black flex flex-col mt-8 md:mt-0 p-8 md:p-12 animate-fade-in">
          <h2 className="text-white text-3xl md:mb-4 text-center self-center lg:self-auto lg:text-left font-bold uppercase">Now Playing</h2>
          <div className="flex flex-col lg:flex-row gap-8">
            <div id="latestRelease" className="flex flex-col lg:basis-3/5 lg:flex-row items-center gap-8 my-8 lg:my-0 lg:py-12 lg:p-8 lg:border-2 lg:border-white/15 lg:bg-white/10 rounded-xl">
              <img className="object-contain border-2 border-orange rounded-2xl lg:size-[250px] xl:size-[300px] 2xl:size-[400px]" src={albumArt} alt="Laugh It Off album artwork"></img>
              <div className="flex flex-col">
                <p className="text-white italic text-center md:text-left text-base md:text-lg font-light uppercase">Latest Single</p>
                <h3 className="text-white text-center md:text-left text-5xl font-bold uppercase">Laugh It Off</h3>
                <a href="https://rohna.tunelink.to/dont-come-down-album" target="_blank" rel="noopener noreferrer" className="text-white text-center uppercase font-bold text-sm mt-4 py-4 lg:text-xl lg:py-4 lg:px-12 rounded-2xl bg-orange transition-all duration-300 ease-in-out shadow-none hover:shadow-orange/50 hover:shadow-lg hover:scale-105">Listen Here<span className="sr-only"> (opens in new tab)</span></a>
              </div>
            </div>
            <div id="latestVideo" className="lg:basis-2/5 flex flex-col gap-2 p-4 md:p-8 lg:border-2 lg:border-white/15 lg:bg-white/10 rounded-2xl">
              <h3 className="text-white italic text-center md:text-left text-base md:text-lg font-light uppercase">Latest Video</h3>
              <YoutubeEmbed url={'M-ZrIAOr4Tw?si=Xh4lIM_j_d4rHrN0'} title="'Don't Come Down' Music Video" className="border-2 border-white/15 w-full h-[200px] md:h-[300px]"/>
              <div className="text-white text-center md:text-left font-bold uppercase">
                <a href="https://www.youtube.com/watch?v=M-ZrIAOr4Tw" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 border-b border-white transition-all duration-300 ease-in-out hover:scale-105">
                  Watch On Youtube
                  <Icon name="arrow-right" size="md" title="ArrowRight" />
                </a>
              </div>
            </div>
          </div>
        </section>
        <section id="tour" className="bg-white flex flex-col px-2 py-8 md:p-12 animate-fade-in">
          <h2 className="text-black text-center md:text-left md:mb-10 text-7xl font-extrabold uppercase">On Tour</h2>
          <TourDateTable events={events} color="black"/>
        </section>
        <section id="merch" className="bg-brown flex flex-col items-center py-8 md:py-12">
          <h2 className="text-white text-center pb-10 text-5xl font-bold uppercase">Merch</h2>
          <div className="flex flex-col gap-6 justify-center items-center mx-4">
            <a href="https://shop.rohnamusic.com" target="_blank" rel="noopener noreferrer" aria-label="Shop Rohna merchandise (opens in new tab)" className="w-5/6 lg:w-2/3 xl:w-1/3">
              <img
                className="object-contain rounded-2xl w-full cursor-pointer transition-all duration-300 ease-in-out hover:scale-105"
                src={dogShirt}
                alt="A photo of a band t-shirt on a hanger, suspended from the rung of a wooden ladder."
              />
            </a>
            <a href="https://shop.rohnamusic.com" target="_blank" rel="noopener noreferrer" className="text-white text-center uppercase font-bold text-xl px-24 py-4 md:text-3xl md:py-4 md:px-36 rounded-2xl bg-orange transition-all duration-300 ease-in-out shadow-none hover:shadow-orange/50  hover:shadow-lg hover:scale-105">Shop Here<span className="sr-only"> (opens in new tab)</span></a>

          </div>
        </section>
        <section id="gallery" className="bg-white py-8 md:py-10 px-4 md:px-24">
          <div className="flex flex-col gap-3 md:grid md:grid-cols-3 md:grid-rows-2 md:gap-3 md:h-[560px]">
            <img className="rounded-2xl object-cover object-bottom-right w-full h-64 md:h-full md:col-span-1 md:row-span-2" src={crowbar01} alt="Side stage shot of the band performing." />
            <img className="rounded-2xl object-cover w-full h-64 md:h-full md:col-span-2" src={crowbar03} alt="Black and white shot of the crowd, the band is seen performing." />
            <img className="rounded-2xl object-cover w-full h-64 md:h-full md:col-span-1" src={crowbar04} alt=" behind the crowd shot, the crowd is swinging foam glow sticks wildly as the band performs." />
            <img className="rounded-2xl object-cover w-full h-64 md:h-full md:col-span-1" src={crowbar02} alt="Rohna guitarist John crowdsurfs while playing." />
          </div>
        </section>
        <section id="mailingListForm" className="flex flex-col items-center py-8 md:py-10">
          <h2 className="text-white text-center my-6 text-5xl font-bold uppercase">Stay in the Loop</h2>
          <p className="mb-6 mx-2 md:mx-0 text-center text-sm md:text-base">Sign up for announcements, early merch drops and discounts, and other exclusive content. Unsubscribe anytime.</p>
          <MailingListForm />
        </section>
      </main>
      <Footer />
    </>
  )
}